/**
 * Header — the publish modal's title row and close button.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import CloseButton from '../../../../shared/CloseButton';

export function Header({ title, onClose }: { title: string; onClose: () => void }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 12,
      }}
    >
      <div>
        <h3 style={{ margin: 0, fontSize: 12, letterSpacing: '.06em', color: 'var(--nb-subtle)' }}>
          PUBLISH WORKSHOP
        </h3>
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--nb-ink)', marginTop: 3 }}>
          {title}
        </div>
      </div>
      <CloseButton onClick={onClose} />
    </div>
  );
}
